import React from 'react'
import PropTypes from 'prop-types'
import HoldingsListColumn from './HoldingsListColumn'
import classnames from 'classnames'
import {
  MARKET_VALUE,
  MARKET_WEIGHT,
  ASSET_NAME,
} from 'utils/Client/holdingsConstants.js'

import styles from './HoldingsList.module.scss'

const  HoldingsListRow = (props) => {
  const {
    isHeaderRow,
    isFooterRow,
    assetName,
    percentage,
    marketValue,
    classAllocationName,
    isMobile,
    isFirstHeader,
  } = props

  const parseName = (classAllocationName) => {
    if (classAllocationName !== '') {
      return classAllocationName
    }
    return '--'
  }

  const wrapperStyles =  isHeaderRow ?
    classnames(styles.holdingsListHeaderRow, styles.headerDivider) : styles.holdingsListRow

  const itemStyles = isHeaderRow ?
    styles.holdingsListHeader : styles.rowItem

  const assetClassStyles = classnames(itemStyles, styles.displayHeaderDots)
  const marketWeightTitle = isMobile ? '' : 'Weight'

  let assetNameValue = isHeaderRow ? classAllocationName : parseName(assetName)
  let assetWeightValue = isFirstHeader  ? marketWeightTitle : percentage
  let assetMarketValue = isFirstHeader ? 'Market Value' : marketValue

  if (isFooterRow) {
    assetNameValue = ''
    assetWeightValue = ''
  } else if (isHeaderRow && !isFirstHeader) {
    assetWeightValue = ''
    assetMarketValue = ''
  }

  return (
    <div className={wrapperStyles}>
      <HoldingsListColumn
        className={isHeaderRow ? assetClassStyles : itemStyles}
        classAllocationName={classAllocationName}
        type={ASSET_NAME}
        isMobile={isMobile}
        isHeaderRow={isHeaderRow}
        value={assetNameValue} />
      <div className={styles.mobileGroup}>
        {!isMobile && <HoldingsListColumn
          className={itemStyles}
          type={MARKET_WEIGHT}
          isMobile={isMobile}
          classAllocationName={classAllocationName}
          isHeaderRow={isHeaderRow}
          isFooterRow={isFooterRow}
          value={assetWeightValue} />}
        <HoldingsListColumn
          className={itemStyles}
          type={MARKET_VALUE}
          isMarketValue={true}
          isHeaderRow={isHeaderRow}
          isFooterRow={isFooterRow}
          isMobile={isMobile}
          classAllocationName={classAllocationName}
          value={assetMarketValue} />
      </div>
    </div>
  )
}

HoldingsListRow.defaultProps = {
  assetName: '--',
  marketValue: '--',
  percentage: 0,
  isHeaderRow: false,
  isFooterRow: false,
  isMobile: false,
  classAllocationName: null,
  isFirstHeader: false
}

HoldingsListRow.propTypes = {
  assetName: PropTypes.string,
  marketValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  percentage: PropTypes.number,
  isHeaderRow: PropTypes.bool,
  isFooterRow: PropTypes.bool,
  isMobile: PropTypes.bool,
  classAllocationName: PropTypes.string,
  isFirstHeader: PropTypes.bool,
}

export default HoldingsListRow



// WEBPACK FOOTER //
// ./src/components/Client/HoldingsList/HoldingsListRow.jsx